
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTouch as ObiTouchElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-touch.js';
 
 
 

 
 export const ObiTouch = createComponent({
   react: React,
   tagName: 'obi-touch',
   elementClass: ObiTouchElement,
   events: {
     
   }
  });
 
 